<template lang="pug">
    .menu-movil-toggle
        .menu-movil-toggle-content
            //.menu-movil-toggle-content-search
                i.fas.fa-search
                input(placeholder="Search...")
            .menu-movil-toggle-content-list
                .menu-movil-toggle-content-item(v-for="option in lenguageNavSelected")
                    .menu-movil-toggle-content-item-title
                        router-link(:to="option.link", @click="closeNav") {{ option.title }}
                        i.fas.fa-chevron-down(v-if="option.options.length")
                    ul
                        li(v-for="suboption in option.options")
                            router-link.is-dropped(:to="suboption.link") {{ suboption.title }}
</template>

<script>
import $ from 'jquery'
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.$route.meta.lang
    },
    mounted: function(){
        $('.consult-menu-movil-left').on('click', function(){
            $('.menu-movil-toggle').toggleClass('active')
        })

        $('.menu-movil-toggle-content-item-title a').on('click', function(){
            $('.menu-movil-toggle').toggleClass('active')
        })

        $('.menu-movil-toggle-content-list ul li a').on('click', function(){
            $('.menu-movil-toggle').toggleClass('active')
        })

        $('.menu-movil-toggle-content-item-title i').on('click', function(e){
            var element = $(e.currentTarget)
            element.parents('.menu-movil-toggle-content-item').find('ul').slideToggle("fast")
        })

        $('.footer-item-title i').on('click', function(e){
            var element = $(e.currentTarget)
            element.parents('.footer__item').toggleClass('active')
            element.parents('.footer__item').find('.footer-toggle-me').slideToggle('fast')
        })


    },
    methods: {
        closeNav: function(){
            $('.menu-movil-toggle').toggleClass('active')
        }
    },
    data: function(){
        return {
            lenguage: 'EN',
            navOptionsEn: [
                {title: "ABOUT ATP", link: "/en/about/what-we-do", options: [
                    {title: "What We Do", link: "/en/about/what-we-do"},
                    {title: "Our History", link: "/en/about/our-history"},
                    {title: "Management Team", link: "/en/about/management-team"},
                    {title: "Our Portfolio", link: "/en/about/our-portfolio"},
                    {title: "Our Vision for 5G", link: "/en/about/our-vision-for-5g"},
                ]},
                {title: "PRODUCTS", link: "/en/products/small-cells", options: [
                    {title: "Small Cells", link: "/en/products/small-cells"},
                    {title: "DAS", link: "/en/products/das"},
                    {title: "Optical Fiber", link: "/en/products/optical-fiber"},
                    {title: "Towers and Rooftops", link: "/en/products/towers-and-rooftops"},
                ]},
                {title: "PORTFOLIO MANAGEMENT", link: "/en/portfolio/property-developers", options: [
                    {title: "Property Developers", link: "/en/portfolio/property-developers"},
                    {title: "Land Owners", link: "/en/portfolio/property-developers"},
                    {title: "Commercial and Real Estate Owners", link: "/en/portfolio/property-developers"},
                    {title: "Large Venues", link: "/en/portfolio/property-developers"},
                    {title: "Infrastructure Owners", link: "/en/portfolio/property-developers"},
                    {title: "Public Service Companies", link: "/en/portfolio/property-developers"},
                    {title: "City and Street Furniture Owners", link: "/en/portfolio/property-developers"},
                ]},
                {title: "OUR SERVICES", link: "/en/services/we-lease", options: [
                    {title: "We Lease", link: "/en/services/we-lease"},
                    {title: "We Build", link: "/en/services/we-build"},
                    {title: "We Manage", link: "/en/services/we-manage"},
                    {title: "We Buy", link: "/en/services/we-buy"}
                ]},
                {title: "MUNICIPALITIES", link: "/en/municipalities/smart-cities", options: [
                    {title: "Smart Cities", link: "/en/municipalities/smart-cities"},
                    {title: "Internet of Things", link: "/en/municipalities/internet-of-things"},
                    {title: "Public Safety", link: "/en/municipalities/public-safety"}
                ]},
                {title: "CAREERS", link: "/en/careers", options: []},
                {title: "PRESS", link: "/en/press", options: []},
                {title: "PUBLICATIONS", link: "/en/publications", options: []},
                {title: "INVESTORS", link: "/en/investors", options: []},
                {title: "CONTACT", link: "/en/contact", options: []},
            ],


            navOptionsEs: [
               {title: "ACERCA DE ATP", link: "/es/acerca-de-atp/que-hacemos", options: [
                    {title: "Qué Hacemos", link: "/es/acerca-de-atp/que-hacemos"},
                    {title: "Nuestra Historia", link: "/es/acerca-de-atp/nuestra-historia"},
                    {title: "Equipo Directivo", link: "/es/acerca-de-atp/equipo-directivo"},
                    {title: "Nuestro Portafolio", link: "/es/acerca-de-atp/nuestro-portafolio"},
                    {title: "Nuestra Visión 5G", link: "/es/acerca-de-atp/nuestra-vision-5g"},
                ]},
                {title: "PRODUCTOS", link: "/es/productos/small-cells", options: [
                    {title: "Small Cells", link: "/es/productos/small-cells"},
                    {title: "DAS", link: "/es/productos/das"},
                    {title: "Fibra Óptica", link: "/es/productos/fibra-optica"},
                    {title: "Torres y Azoteas", link: "/es/productos/torres-y-azoteas"},
                ]},
                {title: "PORTAFOLIO", link: "/es/portafolio/desarrolladores-de-bienes-raices", options: [
                    {title: "Desarrolladores de Bienes Raíces", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Propietarios de Predios", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Propietarios de Inmuebles Comerciales", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Propietarios de Inmuebles Insignia", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Dueños de Infraestructura", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Organizaciones de Servicios Públicos", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                    {title: "Propietarios de Mobiliario Urbano", link: "/es/portafolio/desarrolladores-de-bienes-raices"},
                ]},
                {title: "SERVICIOS", link: "/es/servicios/alquilamos", options: [
                    {title: "Alquilamos", link: "/es/servicios/alquilamos"},
                    {title: "Construimos", link: "/es/servicios/construimos"},
                    {title: "Administramos", link: "/es/servicios/administramos"},
                    {title: "Compramos", link: "/es/servicios/compramos"}
                ]},
                {title: "MUNICIPIOS", link: "/es/municipios/ciudades-inteligentes", options: [
                    {title: "Ciudades Inteligentes", link: "/es/municipios/ciudades-inteligentes"},
                    {title: "Internet of Things (IoT)", link: "/es/municipios/internet-of-things"},
                    {title: "Seguridad Pública", link: "/es/municipios/seguridad-publica"}
                ]},
                {title: "OPORTUNIDADES", link: "/es/oportunidades", options: []},
                {title: "NOTICIAS", link: "/es/noticias", options: []},
                {title: "PUBLICACIONES", link: "/es/publicaciones", options: []},
                {title: "INVERSIONISTAS", link: "/es/inversionistas", options: []},
                {title: "CONTACTO", link: "/es/contacto", options: []},
            ],
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.navOptionsEn : this.$data.navOptionsEs
        }
    },
    watch: {
        lang: {
            deep: true,
            handler(newValue, oldValue) {
            }
        },
        '$route'(to, from) {
            console.log(this.$route.meta.lang)
            this.$data.lenguage = this.$route.meta.lang
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/molecules/PmNavbarMobile.vue